import React, { useEffect } from 'react';
import { Textarea as ChakraTextArea, TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';

export const Textarea = React.forwardRef<HTMLTextAreaElement, ChakraTextareaProps & { shouldResize?: boolean }>((props, ref) => {
  useEffect(() => {
    if (!props.shouldResize) return;
    const textarea = document.querySelector('textarea');

    if (!textarea) return;

    textarea.style.height = '40px';

    let newHeight = textarea.scrollHeight;

    textarea.style.height = `${newHeight}px`;
  }, [props.shouldResize, props.value]);

  return <ChakraTextArea ref={ref} {...props} rows={1} minH={'40px'} resize={'none'} overflow={'hidden'} />;
});

Textarea.displayName = 'Textarea';
